import React from "react";
import { Typography, Divider, List, Card } from "antd";
import { StyledPrivacyPolicy } from "../PrivacyPolicy/styles";
import { APP_EMAIL } from "../../../utils/AiService/constant";

const { Title, Paragraph, Text } = Typography;

const Compliance = () => {
  return (
    <StyledPrivacyPolicy>
      <div className="privacy-container">
        <Card className="privacy-card">
          <Title level={2} className="privacy-title">
            Compliance & Security
          </Title>
          <Text className="last-updated">Last updated: February 2026</Text>

          <Divider />

          <Paragraph>
            At Kelu, compliance isn't an afterthought. It’s built into
            everything we do.
          </Paragraph>

          <Divider />

          {/* UK GDPR */}
          <section className="privacy-section">
            <Title level={4}>UK GDPR COMPLIANT ✓</Title>

            <Paragraph>
              Kelu is designed from the ground up to help your business stay
              GDPR compliant:
            </Paragraph>

            <List
              dataSource={[
                "All data stored in UK/EU servers",
                "Encryption in transit and at rest",
                "Full audit trails of all messages",
                "Data export and deletion tools",
                "Data Processing Agreement available on request",
              ]}
              renderItem={(item) => <List.Item>- {item}</List.Item>}
            />
          </section>

          {/* Data Security */}
          <section className="privacy-section">
            <Title level={4}>DATA SECURITY ✓</Title>

            <List
              dataSource={[
                "SSL/TLS encryption on all connections",
                "Encrypted data storage",
                "Role-based access controls",
                "Secure authentication",
                "Regular security testing",
              ]}
              renderItem={(item) => <List.Item>- {item}</List.Item>}
            />
          </section>

          {/* Regulated Industries */}
          <section className="privacy-section">
            <Title level={4}>BUILT FOR REGULATED INDUSTRIES ✓</Title>

            <Paragraph>
              Kelu is specifically designed for industries with strict
              compliance needs:
            </Paragraph>

            <Divider />

            <Title level={5}>Care Homes</Title>
            <List
              dataSource={[
                "Secure family communication",
                "Full message audit trails",
                "Staff access controls",
              ]}
              renderItem={(item) => <List.Item>- {item}</List.Item>}
            />

            <Title level={5} style={{ marginTop: 20 }}>
              Estate Agents
            </Title>
            <List
              dataSource={[
                "GDPR-compliant client messaging",
                "Conversation history retained",
                "No data loss when staff leave",
              ]}
              renderItem={(item) => <List.Item>- {item}</List.Item>}
            />

            <Title level={5} style={{ marginTop: 20 }}>
              Financial Services
            </Title>
            <List
              dataSource={[
                "Compliant client communication",
                "Message archiving",
                "Multi-branch oversight",
              ]}
              renderItem={(item) => <List.Item>- {item}</List.Item>}
            />

            <Title level={5} style={{ marginTop: 20 }}>
              Healthcare
            </Title>
            <List
              dataSource={[
                "Secure patient messaging",
                "Appointment management",
                "Staff accountability",
              ]}
              renderItem={(item) => <List.Item>- {item}</List.Item>}
            />
          </section>

          {/* DPA */}
          <section className="privacy-section">
            <Title level={4}>DATA PROCESSING AGREEMENT</Title>

            <Paragraph>
              Need a DPA for your compliance records? Email{" "}
              <strong>{APP_EMAIL}</strong> and we’ll provide one within 5
              business days.
            </Paragraph>
          </section>

          {/* Certifications */}
          <section className="privacy-section">
            <Title level={4}>CERTIFICATIONS</Title>

            <Paragraph>We are working towards:</Paragraph>

            <List
              dataSource={["Cyber Essentials (Q3 2026)", "ISO 27001 (Q4 2026)"]}
              renderItem={(item) => <List.Item>- {item}</List.Item>}
            />
          </section>

          {/* Questions */}
          <section className="privacy-section">
            <Title level={4}>QUESTIONS?</Title>

            <Paragraph>
              For any compliance or security questions:
              <br />
              <strong>{APP_EMAIL}</strong>
            </Paragraph>

            <Paragraph>
              We aim to respond within 24 hours on business days.
            </Paragraph>
          </section>
        </Card>
      </div>
    </StyledPrivacyPolicy>
  );
};

export default Compliance;
